// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonProfileLogo_wrapper__slOBr"};